import { render, staticRenderFns } from "./CrearCargoV2.vue?vue&type=template&id=27df2dd0&scoped=true"
import script from "./CrearCargoV2.vue?vue&type=script&lang=js"
export * from "./CrearCargoV2.vue?vue&type=script&lang=js"
import style0 from "./CrearCargoV2.vue?vue&type=style&index=0&id=27df2dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27df2dd0",
  null
  
)

export default component.exports